import { IKid } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const editChild = async (childData: IKid) => {
    return await fetchIStatus<string, IKid>(
        '/api/patients/kid',
        'PUT',
        childData,
    );
};
